import { render, staticRenderFns } from "./MensajesEnviados.vue?vue&type=template&id=0dc7f1cb&"
import script from "./MensajesEnviados.vue?vue&type=script&lang=js&"
export * from "./MensajesEnviados.vue?vue&type=script&lang=js&"
import style0 from "./MensajesEnviados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VDataTable,VSimpleCheckbox})
